import { Box, Button, Container, Paper, Stack, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import React, { useEffect, useState } from "react";

const tokens = {
  teal: "#0F8B8D",
  tealDark: "#0A5F60",
  headingFont: "'Sora', sans-serif",
};

const fadeInUp = {
  "@keyframes fadeInUp": {
    from: { opacity: 0, transform: "translateY(16px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
};

const GetStarted = ({ id }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    fetch(
      `https://aps.songjukti.com/profile/login/api_webland/bottom_banner.php?eid=${id}`
    )
      .then((res) => res.json())
      .then((result) => setData(result?.[0] || {}))
      .catch((error) => {
        console.log("banner started fetch Failed ", error);
      });
  }, [id]);

  if (!data?.title) return null;

  return (
    <Container sx={{ mb: { xs: 4, md: 6 } }}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: "24px",
          overflow: "hidden",
          background: `linear-gradient(120deg, ${tokens.tealDark} 0%, ${tokens.teal} 100%)`,
          p: { xs: 3, md: 5 },
          ...fadeInUp,
          animation: "fadeInUp 0.55s ease both",
        }}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 3, md: 4 }}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack sx={{ width: { xs: "100%", md: "62%" } }} spacing={1.5}>
            <Typography
              sx={{
                fontFamily: tokens.headingFont,
                fontSize: { xs: "17pt", md: "22pt" },
                fontWeight: 700,
                color: "white",
              }}
            >
              {data.title}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "10.5pt", md: "12pt" },
                color: "rgba(255,255,255,0.85)",
              }}
            >
              {data.info}
            </Typography>
            <Stack direction="row" spacing={1.5} sx={{ pt: 1 }} flexWrap="wrap">
              {data.button_1 && (
                <Button
                  variant="contained"
                  href={data.button_1_url}
                  endIcon={<ArrowForwardRoundedIcon />}
                  sx={{
                    bgcolor: "white",
                    color: tokens.tealDark,
                    borderRadius: "24px",
                    textTransform: "capitalize",
                    fontWeight: 700,
                    transition: "background-color 0.2s ease, transform 0.15s ease",
                    "&:hover": { bgcolor: "rgba(255,255,255,0.9)", transform: "translateY(-2px)" },
                  }}
                >
                  {data.button_1}
                </Button>
              )}
              {data.button_2 && (
                <Button
                  variant="outlined"
                  href={data.button_2_url}
                  sx={{
                    borderColor: "rgba(255,255,255,0.6)",
                    color: "white",
                    borderRadius: "24px",
                    textTransform: "capitalize",
                    fontWeight: 700,
                    transition: "border-color 0.2s ease, background-color 0.2s ease, transform 0.15s ease",
                    "&:hover": {
                      borderColor: "white",
                      bgcolor: "rgba(255,255,255,0.08)",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  {data.button_2}
                </Button>
              )}
            </Stack>
          </Stack>
          <Box
            sx={{
              width: { xs: "60%", md: "30%" },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              component="img"
              alt="Get started"
              src={data.banner_pic}
              sx={{
                width: "100%",
                borderRadius: "16px",
              }}
            />
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
};

export default GetStarted;